import { useMutation } from "@tanstack/react-query";
import * as API from "./index";

export const authMutationFactory = () => {
  return {
    login: () => {
      return useMutation({
        mutationFn: ({
          email,
          password,
          device_id,
        }: {
          email: string;
          password: string;
          device_id: string;
        }) => API.login(email, password, device_id),
      });
    },
  };
};

export const authQueryFactory = {
  changePassword: () => {
    return useMutation({
      mutationFn: (params: { oldPassword: string; newPassword: string }) =>
        API.changePassword(params.oldPassword, params.newPassword),
      onSuccess: () => {
        toast.success("Password changed successfully");
      },
      onError: () => {
        toast.error("Failed to change password");
      },
    });
  },
  resetPassword: () => {
    return useMutation({
      mutationFn: (params: {
        email: string;
        first_name: string;
        last_name: string;
        gym_name: string;
      }) => API.resetPassword(params),
      onSuccess: () => {
        toast.success("Check your email for the password reset link");
      },
      onError: () => {
        toast.error("Failed to reset password");
      },
    });
  },
};
